module.exports = __webpack_public_path__ + "static/img/erweima1.4c71736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima1.png
// module id = pEbp
// module chunks = 1